import React from 'react';
import ReactFlow, { useStore, useZoomPanHelper, ReactFlowProvider } from 'react-flow-renderer';
import { getLayoutedElements } from 'src/views/shared/flowProcess';
import { makeStyles } from '@material-ui/core';
import StepNode from './StepNode';
import AddNode from './AddNode';
import CustomEdge from './CustomEdge';
import {
  ACTION,
  ADD_ACTION,
  ADD_TRIGGER,
  CONDITION,
  ACTION_EDGE,
  START_PROCESS,
  TRIGGER,
} from './constants';
import StartProcessNode from './StartProcessNode';

const nodeTypes = {
  [ACTION]: StepNode,
  [START_PROCESS]: StartProcessNode,
  [CONDITION]: StepNode,
  [TRIGGER]: StepNode,
  [ADD_ACTION]: AddNode,
  [ADD_TRIGGER]: AddNode,
};

const edgeTypes = {
  [ACTION_EDGE]: CustomEdge
};

const Process = (props: any) => (
  <ReactFlowProvider>
    <Content {...props} />
  </ReactFlowProvider>
);

const useStyles = makeStyles((theme) => ({
  isCompleted: {
    '& .react-flow__edge-path': {
      stroke: theme.palette.success.main,
      opacity: 0.25,
    }
  },
  dialogPaper: {
    minHeight: '90vh',
    maxHeight: '90vh',
    borderRadius: theme.spacing(3)
  },
}));

const Content = ({
  elements,
  focusedNodeId,
  ...props
}: any) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const store = useStore();
  const { setCenter } = useZoomPanHelper();

  const focusNode = () => {
    const { nodes } = store.getState();

    if (nodes.length) {
      const node = nodes.find((_node) => _node.id === focusedNodeId);

      // @ts-ignore
      const x = node.__rf.position.x + node.__rf.width / 2;
      // @ts-ignore
      const y = node.__rf.position.y + node.__rf.height / 2;

      setCenter(x, y, 0.8);
    }
  };

  const onLoad = (reactFlowInstance: any) => {
    window.setTimeout(() => {
      if (focusedNodeId) {
        focusNode();
      } else {
        reactFlowInstance.fitView();
        reactFlowInstance.zoomTo(1);
      }
      setIsLoading(false);
    }, 100);
  };

  const layouted = getLayoutedElements(elements);

  return (
    <ReactFlow
      id="meow"
      style={{ opacity: isLoading ? 0 : 1 }} // fixes rendering issue where fit to view fits to wrong view
      elements={layouted}
      onLoad={onLoad}
      nodeTypes={nodeTypes}
      edgeTypes={edgeTypes}
      {...props}
    />
  );
};

export default Process;
